import { gql } from "@apollo/client";

export const IMPORTAR_PRECIO_MASIVO = gql`
    mutation ImportarPrecioMasivo(
        $contratos: String!
    ){
    importarPrecioMasivo(
            contratos: $contratos       
    ) 
}
`;